var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":_vm.column}},[_c('div',[_c('label',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }